export default "/images/8d2367e0e351e974ef5ff756e95c2500.jpg";